<template>
  <el-dialog
    title="详情 "
    :visible.sync="dialogVisible"
    width="30%"
    custom-class="answerInfo_dialog"
    destroy-on-close
    class="survey-info"
  >
    <div class="right-top">
      <el-button class="el-button el-button--text" type="text" @click="$del()"
        >删除</el-button
      >
      <el-button
        class="export-btn el-button el-button--text"
        v-if="flag"
        type="text"
        @click="download"
        >导出</el-button
      >
    </div>

    <div class="aLine"></div>

    <div class="list">
      <div class="wrap">
        <div class="title">基本信息</div>
        <div class="item" v-for="item in basic_info" :key="item.label">
          <div>
            <div class="label">{{ item.label }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="wrap" style="margin-top: 40px">
        <div class="title">答题详情</div>
        <div class="item" v-for="item in answer_info" :key="item.id">
          <div class="label">{{ item.label }}</div>
          <div class="text">
            <p v-text="getValue(item)" v-if="item.type == 'text'||item.type=='textarea'"></p>
            <el-image
              style="height: 170px; margin-left: 20px"
              :src="getValue(item)"
              :preview-src-list="[getValue(item)]"
              fit="contain"
              v-if="item.type == 'image'"
              lazy
            ></el-image>
            <a
              target="_blank"
              :href="getValue(item)"
              v-if="item.type == 'upload'"
              >附件下载</a
            >
          </div>
        </div>
      </div>

      <!-- <div class="more" v-if="!isAudit"> -->
    </div>
    <div class="aLine" v-if="(is_audit && isAudit) || !isAudit"></div>
    <div class="audit" v-if="is_audit && isAudit">
      <div
        :class="result_audit ? 'title' : 'title faild'"
        v-text="result_audit ? '审核成功' : '审核失败'"
      ></div>
      <p>备注</p>
      <p>{{ remark_text }}</p>
    </div>
    <div class="more" v-if="!isAudit">
      <div class="label">备注</div>
      <el-input v-model="remark"></el-input>
    </div>
    <span slot="footer" class="dialog-footer" v-if="!isAudit">
      <el-button @click="$reject()">拒绝</el-button>
      <el-button type="primary" @click="$pass()">通过</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";

export default {
  data() {
    return {
      dialogVisible: false,
      is_audit: false, //是否是审核的问卷
      answer_info: null, // 答案详情
      remark: "", // 备注
      id: "",
      isAudit: false, //是否已审批,
      answer_id: "", //导出的问卷id
      flag: false, //是否是回收列表的数据
      basic_info: [{ label: "", text: "" }],
      remark_text: "", // 该表是审核表并且是已经审核完成的表的备注信息
      result_audit: true,
      survey_id: ""
    };
  },
  methods: {
    show(msg) {
      // 重置数据
      this.remark = "";
      this.basic_info = [{ label: "", text: "" }];
      // 判断是否已经审核
      this.isAudit = msg.info.result == "wait" ? false : true;
      // msg.flag判断是审核表还是回收表
      if (msg.flag) {
        this.flag = msg.flag;
      } else {
        this.flag = false;
      }
      // 判断问卷是否是审核表，是的话回收表显示备注信息
      if (msg.is_audit) {
        if (msg.is_audit == "Y") {
          this.is_audit = true;
        }
      }
      // 该问卷的id
      this.id = msg.info.id;
      this.survey_id = msg.info.survey_id;
      // 答题详情
      this.getInfo();
      this.answer_info = msg.arr;
      this.dialogVisible = true;
      this.answer_id = msg.info.answer_id;
    },
    getInfo() {
      this.$api
        .answerInfo({
          token: localStorage.getItem("token"),
          sheet_answer_id: this.id
        })
        .then(({ data }) => {
          if (data.Data) {
            // 基本信息
            this.basic_info.push({
              label: "编号",
              text: data.Data.answer_id || "未知"
            });
            this.basic_info.push({
              label: "中文姓名",
              text: data.Data.name_cn || "未知"
            });
            this.basic_info.push({
              label: "英文姓名",
              text: data.Data.name_en || "未知"
            });
            this.basic_info.push({
              label: "性别",
              text: data.Data.gender || "未知"
            });
            this.basic_info.push({
              label: "学号",
              text: data.Data.student_no || "未知"
            });
            this.basic_info.push({
              label: "工作状态",
              text: data.Data.status || "未知"
            });
            this.basic_info.push({
              label: "入学年份",
              text: data.Data.year || "未知"
            });
            this.basic_info.push({
              label: "毕业年份",
              text: data.Data.graduation_year || "未知"
            });
            this.basic_info.push({
              label: "学部",
              text: data.Data.division || "未知"
            });
            this.basic_info.push({
              label: "身份证号码",
              text: data.Data.id_card_number || "未知"
            });
          }
          if (this.is_audit) {
            this.remark_text = data.Data.remark;
            data.Data.result == "success"
              ? (this.result_audit = true)
              : (this.result_audit = false);
          }
        })
        .catch(({ error }) => {});
    },
    $pass() {
      this.$api
        .allowAnswer({
          token: localStorage.getItem("token"),
          ids: JSON.stringify([this.id]),
          remark: this.remark
        })
        .then(({ data }) => {
          this.dialogVisible = false;
          this.$root.$emit("refresh_list", "审核通过成功");
        })
        .catch(({ error }) => {});
    },
    $reject() {
      this.$api
        .notAllowAnswer({
          token: localStorage.getItem("token"),
          ids: JSON.stringify([this.id]),
          remark: this.remark
        })
        .then(({ data }) => {
          this.dialogVisible = false;
          this.$root.$emit("refresh_list", "审核拒绝成功");
        })
        .catch(({ error }) => {});
    },
    // 获取答案详情
    getValue(val) {
      if (val.type != "text"&&val.type!="textarea") {
        return URL_PATH + val.text;
      } else {
        return val.text;
      }
    },
    // 导出
    download() {
      this.$root.$emit("export_answer", this.answer_id);
    },
    // 删除待审核问卷
    $del() {
      this.$confirm("是否删除该问卷答案", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$api
            .delAnswer({
              token: localStorage.getItem("token"),
              survey_id: this.survey_id,
              answer_ids: JSON.stringify([this.answer_id])
            })
            .then(({ data }) => {
              this.dialogVisible = false;
              if (this.flag) {
                this.$root.$emit("answerList_refresh_list", "删除成功");
              } else {
                this.$root.$emit("refresh_list", "删除成功");
              }
            })
            .catch(({ error }) => {});
        })
        .catch(() => {});
    }
  },
  created() {
    this.$root.$on("showAnswerInfo", (msg) => {
      this.show(msg);
    });
  },
  beforeDestroy() {
    this.$root.$off("showAnswerInfo");
  }
};
</script>
<style scoped>
.right-top {
  position: absolute;
  right: 75px;
  top: 8px;
  color: inherit;
}
.el-button--text:hover {
  color: #66b1ff;
}
.list .item {
  margin-bottom: 16px;
}
.list .item .label {
  min-width: 70px;
  color: #bfbfbf;
  margin-bottom: 16px;
}
.list {
  padding: 0 30px 10px;
  max-height: 60vh !important;
  overflow-y: scroll;
  margin-right: 5px;
}
.more {
  padding: 0 30px;
  margin-right: 5px;
  margin-top: 20px;
}
.more .label {
  white-space: nowrap;
  margin-right: 16px;
  margin-bottom: 8px;
}
.aLine {
  background-color: #e9e9e9;
  height: 1px;
  margin: 10px 30px;
}
.list .title {
  font-size: 16px;
  color: #000000;
  margin: 16px 0;
}
.audit {
  margin: 16px 30px 40px;
}
.audit .title {
  color: #4d8bf8;
  font-size: 18px;
  margin-bottom: 16px;
}
.audit .title.faild {
  color: #f84d4d;
}
</style>
<style>
.answerInfo_dialog {
  width: 50% !important;
  margin-top: 5vh !important;
}
.answerInfo_dialog .el-dialog__body {
  padding: 0;
  padding-bottom: 20px;
}
</style>
<style>
.answerInfo_dialog .el-dialog__header {
  padding-left: 30px;
}
.survey-info div::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /**/
}
.survey-info div::-webkit-scrollbar-track {
  background: rgb(255, 255, 255);
  border-radius: 2px;
}
.survey-info div::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
.survey-info div::-webkit-scrollbar-thumb:hover {
  background: rgb(156, 156, 156);
}
.survey-info div::-webkit-scrollbar-corner {
  background: #efefef;
}
</style>


// WEBPACK FOOTER //
// src/components/survey/answerInfo.vue